export const nonBooleanMapper = {
    afterHoursDesc: "After Hours(Urgent Care) Visits",
    preventativeCareDesc: "Preventative Care",
    officeVisitsPerMonth: "Max Office Visits (Per Month)"
};